/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ startDate: NonNullable<unknown>, startTime: NonNullable<unknown>, endDate: NonNullable<unknown> }} Campaigns_Mag7_Fine_Print_DatesInputs */

const en_campaigns_mag7_fine_print_dates = /** @type {(inputs: Campaigns_Mag7_Fine_Print_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rewards run from ${i?.startDate} at ${i?.startTime} through ${i?.endDate}.`)
};

const de_campaigns_mag7_fine_print_dates = /** @type {(inputs: Campaigns_Mag7_Fine_Print_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Der Prämienzeitraum läuft vom ${i?.startDate} um ${i?.startTime} bis zum ${i?.endDate}.`)
};

const pt_br2_campaigns_mag7_fine_print_dates = /** @type {(inputs: Campaigns_Mag7_Fine_Print_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`As recompensas valem de ${i?.startDate}, às ${i?.startTime}, até ${i?.endDate}.`)
};

const tr_campaigns_mag7_fine_print_dates = /** @type {(inputs: Campaigns_Mag7_Fine_Print_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ödül dönemi ${i?.startDate} tarihinde saat ${i?.startTime} itibarıyla başlar ve ${i?.endDate} tarihinde sona erer.`)
};

const zh_cn2_campaigns_mag7_fine_print_dates = /** @type {(inputs: Campaigns_Mag7_Fine_Print_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`奖励发放期为 ${i?.startDate} ${i?.startTime} 起至 ${i?.endDate} 止。`)
};

const zh_hk2_campaigns_mag7_fine_print_dates = /** @type {(inputs: Campaigns_Mag7_Fine_Print_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`獎賞由 ${i?.startDate} ${i?.startTime} 起至 ${i?.endDate} 止。`)
};

const ko_kr2_campaigns_mag7_fine_print_dates = /** @type {(inputs: Campaigns_Mag7_Fine_Print_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`리워드는 ${i?.startDate} ${i?.startTime}부터 ${i?.endDate}까지 적용됩니다.`)
};

const ru_ru2_campaigns_mag7_fine_print_dates = /** @type {(inputs: Campaigns_Mag7_Fine_Print_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вознаграждения начисляются с ${i?.startDate} в ${i?.startTime} по ${i?.endDate}.`)
};

const es_419_campaigns_mag7_fine_print_dates = /** @type {(inputs: Campaigns_Mag7_Fine_Print_DatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Las recompensas van desde el ${i?.startDate} a las ${i?.startTime} hasta el ${i?.endDate}.`)
};

/**
* | output |
* | --- |
* | "Rewards run from {startDate} at {startTime} through {endDate}." |
*
* @param {Campaigns_Mag7_Fine_Print_DatesInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_fine_print_dates = /** @type {((inputs: Campaigns_Mag7_Fine_Print_DatesInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Fine_Print_DatesInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_fine_print_dates(inputs)
	if (locale === "de") return de_campaigns_mag7_fine_print_dates(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_fine_print_dates(inputs)
	if (locale === "tr") return tr_campaigns_mag7_fine_print_dates(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_fine_print_dates(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_fine_print_dates(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_fine_print_dates(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_fine_print_dates(inputs)
	return es_419_campaigns_mag7_fine_print_dates(inputs)
});